module.exports = __webpack_public_path__ + "9bd0e92ed7c9c079ffca8506583b6cc9.png";